import React from 'react'
import FreelancerSelectCity from '../FreelancerCreate/FreelancerSelectCity'
import FreelancerSearchCity from '../FreelancerCreate/FreelancerSearchCity'
import { useHistory, useOnboardConfig } from 'utils'

// Helper function to check if onboardConfig includes an item with a specific name
const hasConfigItem = (config, itemName) => {
  if (!config || !Array.isArray(config)) return false;
  return config.some(item => item.name === itemName && item.enabled !== false);
}

const FreelancerCity = ({ user, markets, setSnackMessage }) => {
  const history = useHistory()
  const onboardConfig = useOnboardConfig()

  console.log(onboardConfig)

  return (
    <>
      {onboardConfig && hasConfigItem(onboardConfig, 'selectCity') ? (
        <FreelancerSelectCity
          user={user}
          markets={markets}
          onSubmit={() => {
            setSnackMessage('Your city has been successfully updated')
            history.push('/settings')
          }}
        />
      ) :
      onboardConfig && hasConfigItem(onboardConfig, 'searchCity') ? (
        <FreelancerSearchCity
          user={user}
          markets={markets}
          onSubmit={() => {
            setSnackMessage('Your cities have been successfully updated')
            history.push('/settings')
          }}
        />
      ): null}
    </>
  )
}

export default FreelancerCity
